import React, { FC } from "react";
import { styled } from "@mui/system";
import { COLORS, GAPS } from "../../common/consts";
import Text, { TextVariant } from "../../components/Display/Text";
import Grid from "../../components/Display/Grid";
import Button, { ButtonVariants, ButtonSizes } from "../../components/Display/Button";
import { ReactComponent as OutreachIcon } from "../../assets/icons/outreach-icon.svg";

const IntegrationCard = styled("div")`
  border: 1px solid var(--color-borderTertiary, ${COLORS.borderTertiary});
  border-radius: 8px;
  padding: ${GAPS.lg};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: var(--color-backgroundWhite, ${COLORS.backgroundWhite});
  
  &:hover {
    border-color: var(--color-foregroundBrand, ${COLORS.foregroundBrand});
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

const IconWrapper = styled("div")<{ background: string }>`
  background: ${({ background }) => background};
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${GAPS.sm};
`;

const HubSpotIcon = styled("div")`
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #ff7a59 0%, #ff6b35 100%);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 14px;
`;

interface ChooseIntegrationProps {
  onSelectHubSpot?: () => void; // HubSpot functionality excluded - made optional
  onSelectOutreach: () => void;
}

const ChooseIntegration: FC<ChooseIntegrationProps> = ({
  onSelectHubSpot,
  onSelectOutreach,
}) => {
  return (
    <Grid container direction="column" gap={GAPS.lg}>
      <Text variant={TextVariant.md} style={{ textAlign: "center" }}>
        Choose your integration
      </Text>
      <Text
        variant={TextVariant.sm}
        color={COLORS.foregroundSecondary}
        style={{ textAlign: "center" }}
      >
        Select which platform you want to connect with
      </Text>
      <Grid container gap={GAPS.md} style={{ marginTop: GAPS.md }}>
        <IntegrationCard 
          onClick={onSelectOutreach}
          style={{ flex: 1, minWidth: "150px" }}
        >
          <Grid container direction="column" alignItems="center">
            <IconWrapper background={COLORS.foregroundBrand}>
              <OutreachIcon color={COLORS.foregroundWhite} />
            </IconWrapper>
            <Text variant={TextVariant.md} style={{ marginBottom: GAPS.xs }}>
              Outreach
            </Text>
            <Text
              variant={TextVariant.sm}
              color={COLORS.foregroundSecondary}
              style={{ textAlign: "center" }}
            >
              Connect with your Outreach account
            </Text>
          </Grid>
        </IntegrationCard>
        {/* HubSpot functionality excluded */}
        {onSelectHubSpot && (
          <IntegrationCard 
            onClick={onSelectHubSpot}
            style={{ flex: 1, minWidth: "150px" }}
          >
            <Grid container direction="column" alignItems="center">
              <IconWrapper background="#ff7a59">
                <HubSpotIcon>HS</HubSpotIcon>
              </IconWrapper>
              <Text variant={TextVariant.md} style={{ marginBottom: GAPS.xs }}>
                HubSpot
              </Text>
              <Text
                variant={TextVariant.sm}
                color={COLORS.foregroundSecondary}
                style={{ textAlign: "center" }}
              >
                Connect with your HubSpot account
              </Text>
            </Grid>
          </IntegrationCard>
        )}
      </Grid>
    </Grid>
  );
};

export default ChooseIntegration;
